<template>
  <div id="menuTop" class="font-1 d-flex px-3 w-100" :class="menu" style="">
    <div class="d-flex h-100 w-100 topSpace">
      <div class=" col-8 d-flex justify-content-start align-items-center h-100">
        <div
          class="col-xxl-12 col-xl-10 col-lg-10 col-md-6  col-8 col-sm-8 d-flex justify-content-start align-items-center h-100"
          @click="goTo('home')">
          <img :src="computedLogo" class="logo cursor-pointer_mod">
        </div>
        <div
          class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-4 col-4 d-flex justify-content-end align-items-center h-100 nuevos-enlaces vanish visible">

          <a class="linkAccess3 link w-100 font-7 my-" :class="{ active: $route.name === 'audio' }"
            @click="goTo('audio')">AUDIO</a>

          <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'video' }"
            @click="goTo('video')">VIDEO</a>

          <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'datos' }"
            @click="goTo('datos')">DATOS</a>

          <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'domotica' }"
            @click="goTo('domotica')">DOMÓTICA</a>

          <span class="barra-lateral"></span>
        </div>

      </div>
      <span class="linea-lateral"></span>
      <div class=" col-4 d-flex justify-content-end align-items-center h-100" :class="open ? 'open' : 'closed'">
        <span class="icon-action icon-1" @click="toggleMenu">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </span>
      </div>
    </div>

    <div class="fillspace" v-if="open"></div>

    <div :class="menu" class="openSpace d-flex flex-column justify-content-center align-items-start align-content-start"
      v-if="menuSelected === 1">
      <img :src="computedLogo" class="menu-logo" @click="goTo('home')">
      <button class="btn-close-menu" @click="toggleMenu" aria-label="Cerrar menú">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <div class="col-12 d-flex justify-content-start text-start align-items-start align-content-start flex-wrap flex-fill menu-links-container">
  <span class="font-7 menu-subtitle mb-4 fuente-nova" style="--delay: 0">Instalaciones que conectan tecnología con cada espacio</span>

  <a class="menu-link w-100 font-7 my-2"
     :class="{ active: $route.name === 'audio' }"
     @click="goTo('audio')"
     style="--delay: 1">
     <span class="link-indicator"></span>
     Audio
  </a>

  <a class="menu-link w-100 font-7 my-2"
     :class="{ active: $route.name === 'video' }"
     @click="goTo('video')"
     style="--delay: 2">
     <span class="link-indicator"></span>
     Video
  </a>

  <a class="menu-link w-100 font-7 my-2"
     :class="{ active: $route.name === 'datos' }"
     @click="goTo('datos')"
     style="--delay: 3">
     <span class="link-indicator"></span>
     Datos
  </a>

  <a class="menu-link w-100 font-7 my-2"
     :class="{ active: $route.name === 'domotica' }"
     @click="goTo('domotica')"
     style="--delay: 4">
     <span class="link-indicator"></span>
     Domótica
  </a>
</div>

<div class="menu-cta-section" style="--delay: 6">
  <button class="menu-cta-btn fuente-nova2" @click="openContactModal">
    Contáctanos
  </button>
  <button class="menu-cta-btn-outline fuente-nova2" @click="openPricingModal">
    Nuestros Proyectos
  </button>
</div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'menutop',
  props: {
    menu: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      a2: require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png'),
      a5: require('@/assets/images/Fotos Web Proactive/proactivelogoblanco.png'),
      logoBlanco: require('@/assets/images/Fotos Web Proactive/proactivelogoblanco.png'),
      dinW: 0,
      open: false,
      menuSelected: 0,
      showLinks: false
    }
  },
  computed: {
    // El logo sigue al fondo, no a la ruta: la vista actualiza `menu` a
    // 'white' o 'black' según la sección visible al hacer scroll. Antes se
    // forzaba el logo blanco en las 4 secciones, así que desaparecía en
    // cuanto entrabas a una sección de fondo claro.
    computedLogo() {
      return this.menu === 'black' || this.menu === 'dark' ? this.logoBlanco : this.a2;
    }
  },
  async created() {
    const img1 = new Image();
    img1.src = await require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png');
    const img2 = new Image();
    img2.src = await require('@/assets/images/Fotos Web Proactive/proactivelogoblanco.png');
    this.showLinks = true;
    // setTimeout(() => {
    //     this.showLinks = true;
    // }, 2000);
  },
  mounted() {
    this.getDinW();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(e) {
      if (e.key === 'Escape' && this.open) {
        this.toggleMenu();
      }
    },
    toggleMenu() {
      this.open = this.menuSelected === 0;
      this.menuSelected = this.open ? 1 : 0;
    },
    getDinW() {
      const container = document.getElementById('master');
      if (container) {
        this.dinW = (container.offsetWidth - container.clientWidth > 0) ? container.offsetWidth - container.clientWidth : container.offsetWidth - 15;
        setTimeout(() => {
          this.dinW = container.offsetWidth - container.clientWidth;
        }, 1000);
      }
    },
    goTo(section) {
      this.$router.push({ name: section });
    },
    openContactModal() {
      this.toggleMenu();
      setTimeout(() => {
        import('bootstrap').then(({ Modal }) => {
          const modalEl = document.getElementById('contactModal');
          if (modalEl) {
            const modal = new Modal(modalEl);
            modal.show();
          }
        });
      }, 300);
    },
    openPricingModal() {
      this.toggleMenu();
      setTimeout(() => {
        import('bootstrap').then(({ Modal }) => {
          const modalEl = document.getElementById('pricingModal');
          if (modalEl) {
            const modal = new Modal(modalEl);
            modal.show();
          }
        });
      }, 300);
    }
  }
}
</script>

<style lang="css" scoped>
.fade-enter-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.menu-logo {
  position: absolute;
  top: 48px;
  left: 20px;
  height: 28px;
  width: auto;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.menu-logo:hover {
  opacity: 0.7;
}

.menu-links-container {
  padding-top: 20px;
}

.btn-close-menu {
  position: absolute;
  top: 32px;
  right: 28px;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: #666;
  cursor: pointer;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.btn-close-menu:hover {
  color: #000;
  background: rgba(0, 0, 0, 0.05);
}

.black .btn-close-menu,
.dark .btn-close-menu {
  color: rgba(255, 255, 255, 0.6);
}

.black .btn-close-menu:hover,
.dark .btn-close-menu:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

/* El encabezado mide 80px: el logo tiene que caber dentro con aire.
   El contenedor ya centra vertical (align-items-center), así que no lleva
   margin-top; antes 68px + 25px de margen sumaban 93px y el bajotítulo
   se salía de la barra sobre la imagen del hero. */
.logo {
  width: auto;
  height: 44px;
  margin-left: 20px;
}

.nuevos-enlaces {
  z-index: 1010;
  margin-left: 100px;
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.nuevos-enlaces.visible {
  opacity: 1;
}

.nuevos-enlaces a {
  margin: 0 20px;
  color: #000000;
}

.white .linkAccess3.active {
  color: #000000 !important;
}

.black .linkAccess3.active {
  color: #ffffff !important;
}

.menu-subtitle {
  font-size: 14px;
  color: #888;
  font-weight: 400;
  line-height: 1.5;
  opacity: 0;
  transform: translateX(20px);
  animation: slideIn 0.4s ease forwards;
  animation-delay: calc(var(--delay) * 0.08s);
}

.menu-link {
  font-size: 28px;
  color: #333;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transform: translateX(20px);
  animation: slideIn 0.4s ease forwards;
  animation-delay: calc(var(--delay) * 0.08s);
  transition: color 0.2s ease;
}

.menu-link:hover {
  color: #000;
}

.menu-link.active {
  color: #000;
  font-weight: 600;
}

.link-indicator {
  width: 0;
  height: 3px;
  background-color: var(--color-2);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.menu-link.active .link-indicator {
  width: 20px;
}

.menu-link:hover .link-indicator {
  width: 12px;
}

.black .menu-subtitle,
.dark .menu-subtitle {
  color: rgba(255, 255, 255, 0.5);
}

.black .menu-link,
.dark .menu-link {
  color: rgba(255, 255, 255, 0.7);
}

.black .menu-link:hover,
.dark .menu-link:hover {
  color: #fff;
}

.black .menu-link.active,
.dark .menu-link.active {
  color: #fff;
}

.menu-cta-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 35px 35px 35px;
  opacity: 0;
  transform: translateX(20px);
  animation: slideIn 0.4s ease forwards;
  animation-delay: calc(var(--delay) * 0.08s);
}

.menu-cta-btn {
  width: 100%;
  padding: 14px 24px;
  background-color: var(--color-2);
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  white-space: nowrap;
}

.menu-cta-btn:hover {
  opacity: 0.85;
}

.menu-cta-btn-outline {
  width: 100%;
  padding: 14px 24px;
  background-color: transparent;
  color: var(--color-2);
  border: 2px solid var(--color-2);
  border-radius: 30px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.menu-cta-btn-outline:hover {
  background-color: var(--color-2);
  color: white;
}

.black .menu-cta-btn-outline,
.dark .menu-cta-btn-outline {
  color: white;
  border-color: white;
}

.black .menu-cta-btn-outline:hover,
.dark .menu-cta-btn-outline:hover {
  background-color: white;
  color: var(--color-2);
}

@keyframes slideIn {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.btn2:hover {
  color: var(--color-8) !important;
}

.btn2:hover svg path {
  fill: var(--color-8);
}

.link {
  color: #9c9c9c !important;
}

.link:hover {
  color: #6b6e70 !important;
}

.openSpace {
  height: 100vh;
  max-width: 340px;
  width: 100%;
  position: fixed;
  padding: 35px;
  top: 0;
  padding-top: 115px;
  right: 0;
  border: 1px solid #000;
  z-index: 1050;
  transform: translateX(340px);
  animation: open 0.2s linear forwards;
}

.icon-close {
  position: absolute;
  top: 25px;
  right: 25px;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  z-index: 1100;
  color: #000;
}

@media (max-width: 600px) {
  .openSpace {
    transform: translateX(100vw);
    max-width: 100vw;
    width: 100vw;
  }
}

@keyframes open {
  0% {
    transform: translateX(100vw);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes fadeUp {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.topSpace {
  z-index: 1001;
}

.fillspace {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  width: 100vw;
  height: 100vh;
  animation: fadeUp 0.2s linear forwards;
}

#menuTop {
  position: sticky;
  top: 0;
  left: 0;
  /* opcional si quieres que ocupe todo el ancho del contenedor */
  height: 80px;
  z-index: 1001;
  /* para que quede encima del contenido al hacer scroll */
  /* quitas position: fixed */
}

.label-1 {
  font-size: 22px;
  line-height: 0;
}

.black .label-1,
.dark .label-1 {
  color: var(--color-5);
}

.veige .label-1,
.white .label-1 {
  color: var(--color-1);
}

.white .label-2 {
  color: var(--color-4);
}

.white .linkAccess {
  color: var(--color-3);
}

.white .linkAccess2 {
  color: var(--color-2);
}

.white .linkAccess3 {
  color: var(--color-4);
}

.white .btn2 svg path {
  fill: var(--color-4);
}

.black .label-2,
.black .linkAccess,
.black .linkAccess2,
.black .linkAccess3,
.black .btn2 svg path {
  color: var(--color-5);
  fill: var(--color-5);
}

.dark .label-2,
.dark .linkAccess,
.dark .linkAccess2,
.dark .linkAccess3,
.dark .btn2 svg path {
  color: var(--color-5);
  fill: var(--color-5);
}

.veige .label-2,
.veige .linkAccess,
.veige .linkAccess2,
.veige .linkAccess3,
.veige .btn2 svg path {
  color: var(--color-1);
  fill: var(--color-1);
}

.icon-1 {
  position: relative;
  height: 25px;
  width: 30px;
  cursor: pointer;
  display: block;
}

.line {
  height: 5px;
  width: 100%;
  position: absolute;
  transition: all 0.3s;
}

.line:nth-child(1) {
  top: 0;
}

.line:nth-child(2) {
  top: 50%;
  transform: translateY(-50%);
}

.line:nth-child(3) {
  bottom: 0;
}

.white .line {
  background-color: var(--color-2);
}

.black .line,
.dark .line {
  background-color: var(--color-5);
}

.veige .line {
  background-color: var(--color-1);
}

.white {
  background-color: #fff;
}

.black {
  background-color: var(--color-4);
}

.dark {
  background-color: var(--color-2);
}

.veige {
  background-color: var(--color-9);
}

.label-2 {
  font-size: 25px;
  line-height: 2;
}

.linkAccess,
.linkAccess2,
.linkAccess3 {
  cursor: pointer;
  outline: none;
  text-decoration: none;
}

.linkAccess {
  font-size: 18px;
  line-height: 1.1;
}

.linkAccess2 {
  font-size: 20px;
  line-height: 1.1;
}

.linkAccess3 {
  font-size: 22px;
  line-height: 1.1;
}

.bottomSpace {
  padding-top: 20px;
  border-top: 2px solid var(--color-2);
}

.open .icon-1 .line:nth-child(2) {
  display: none;
}

.open .icon-1 .line:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.open .icon-1 .line:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

.cursor-pointer_mod {
  cursor: pointer;
}

@media screen and (max-width: 1280px) {
  .nuevos-enlaces {
    z-index: 1010;
    margin-left: 50px;
  }
}

@media screen and (max-width: 992px) {
  .nuevos-enlaces {
    display: none !important;
  }
}
</style>
